/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 * @generated-id: 9392014489bb
 */

import { CloudinaryAssetMgmtCore } from "../core.js";
import { encodeFormQuery, encodeSimple, queryJoin } from "../lib/encodings.js";
import { compactMap } from "../lib/primitives.js";
import { safeParse } from "../lib/schemas.js";
import { RequestOptions } from "../lib/sdks.js";
import { extractSecurity, resolveGlobalSecurity } from "../lib/security.js";
import { pathToFunc } from "../lib/url.js";
import { DeliveryTypeAll } from "../models/deliverytypeall.js";
import { DirectionEnum } from "../models/directionenum.js";
import { APIError } from "../models/errors/apierror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { Fields } from "../models/fields.js";
import {
  ListRawFilesRequest,
  ListRawFilesRequest$zodSchema,
} from "../models/listrawfilesop.js";
import { APICall, APIPromise } from "../types/async.js";
import { Result } from "../types/fp.js";

/**
 * Get raw assets
 *
 * @remarks
 * Retrieves a list of raw assets. Results can be filtered by various criteria like tags, prefix, or specific public IDs.
 */
export function assetsListRawFiles(
  client$: CloudinaryAssetMgmtCore,
  type?: DeliveryTypeAll | undefined,
  prefix?: string | undefined,
  public_ids?: Array<string> | undefined,
  tags?: boolean | undefined,
  next_cursor?: string | undefined,
  max_results?: number | undefined,
  direction?: DirectionEnum | undefined,
  start_at?: string | undefined,
  fields?: Fields | undefined,
  options?: RequestOptions,
): APIPromise<
  Result<
    Response,
    | APIError
    | SDKValidationError
    | UnexpectedClientError
    | InvalidRequestError
    | RequestAbortedError
    | RequestTimeoutError
    | ConnectionError
  >
> {
  return new APIPromise($do(
    client$,
    type,
    prefix,
    public_ids,
    tags,
    next_cursor,
    max_results,
    direction,
    start_at,
    fields,
    options,
  ));
}

async function $do(
  client$: CloudinaryAssetMgmtCore,
  type?: DeliveryTypeAll | undefined,
  prefix?: string | undefined,
  public_ids?: Array<string> | undefined,
  tags?: boolean | undefined,
  next_cursor?: string | undefined,
  max_results?: number | undefined,
  direction?: DirectionEnum | undefined,
  start_at?: string | undefined,
  fields?: Fields | undefined,
  options?: RequestOptions,
): Promise<
  [
    Result<
      Response,
      | APIError
      | SDKValidationError
      | UnexpectedClientError
      | InvalidRequestError
      | RequestAbortedError
      | RequestTimeoutError
      | ConnectionError
    >,
    APICall,
  ]
> {
  const input$: ListRawFilesRequest | undefined = {
    type: type,
    prefix: prefix,
    public_ids: public_ids,
    tags: tags,
    next_cursor: next_cursor,
    max_results: max_results,
    direction: direction,
    start_at: start_at,
    fields: fields,
  };

  const parsed$ = safeParse(
    input$,
    (value$) => ListRawFilesRequest$zodSchema.optional().parse(value$),
    "Input validation failed",
  );
  if (!parsed$.ok) {
    return [parsed$, { status: "invalid" }];
  }
  const payload$ = parsed$.value;
  const body$ = null;

  const pathParams$ = {
    cloud_name: encodeSimple("cloud_name", client$._options.cloud_name, {
      explode: false,
      charEncoding: "percent",
    }),
  };
  const path$ = pathToFunc("/v1_1/{cloud_name}/resources/raw")(
    pathParams$,
  );
  const query$ = queryJoin(
    encodeFormQuery({
      "fields": payload$?.fields,
      "public_ids": payload$?.public_ids,
    }, { explode: false }),
    encodeFormQuery({
      "direction": payload$?.direction,
      "max_results": payload$?.max_results,
      "next_cursor": payload$?.next_cursor,
      "prefix": payload$?.prefix,
      "start_at": payload$?.start_at,
      "tags": payload$?.tags,
      "type": payload$?.type,
    }),
  );

  const headers$ = new Headers(compactMap({
    Accept: "application/json",
  }));
  const securityInput = await extractSecurity(client$._options.security);
  const requestSecurity = resolveGlobalSecurity(securityInput);

  const context = {
    options: client$._options,
    baseURL: options?.serverURL ?? client$._baseURL ?? "",
    operationID: "listRawFiles",
    oAuth2Scopes: null,
    resolvedSecurity: requestSecurity,
    securitySource: client$._options.security,
    retryConfig: options?.retries
      || client$._options.retryConfig
      || { strategy: "none" },
    retryCodes: options?.retryCodes || [
      "429",
      "500",
      "502",
      "503",
      "504",
    ],
  };

  const requestRes = client$._createRequest(context, {
    security: requestSecurity,
    method: "GET",
    baseURL: options?.serverURL,
    path: path$,
    headers: headers$,
    query: query$,
    body: body$,
    userAgent: client$._options.userAgent,
    timeoutMs: options?.timeoutMs || client$._options.timeoutMs
      || -1,
  }, options);
  if (!requestRes.ok) {
    return [requestRes, { status: "invalid" }];
  }
  const req$ = requestRes.value;

  const doResult = await client$._do(req$, {
    context,
    errorCodes: [],
    retryConfig: context.retryConfig,
    retryCodes: context.retryCodes,
  });
  if (!doResult.ok) {
    return [doResult, { status: "request-error", request: req$ }];
  }
  return [doResult, {
    status: "complete",
    "request": req$,
    response: doResult.value,
  }];
}
